import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { AppShell } from '@/components/layout/app-shell';
import { Overlays } from '@/features/overlays';
import { PreviewProvider } from '@/features/preview/file-preview';
import { trpc } from '@/lib/trpc';

/** Картка кандидата й участь у конкурсі відкриваються поверх будь-якої сторінки. */
const overlaySearch = z.object({
  candidate: z.uuid().optional().catch(undefined),
  application: z.uuid().optional().catch(undefined),
});

export const Route = createFileRoute('/_app')({
  validateSearch: overlaySearch,
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.query(trpc.auth.me.queryOptions());
    if (!me) throw redirect({ to: '/login', search: { redirect: location.href } });
    // Працівник бачить лише свій кабінет.
    // Працівник бачить свій кабінет і пошту.
    if (
      me.role === 'employee' &&
      !location.pathname.startsWith('/me') &&
      !location.pathname.startsWith('/mail')
    ) {
      throw redirect({ to: '/me' });
    }
    return { me };
  },
  component: AppLayout,
});

function AppLayout() {
  const { me } = Route.useRouteContext();
  const search = Route.useSearch();
  return (
    <PreviewProvider>
      <AppShell user={me}>
        <Outlet />
        <Overlays candidateId={search.candidate} applicationId={search.application} me={me} />
      </AppShell>
    </PreviewProvider>
  );
}
